import modal from '@/utils/modal'
import ProfileSkinSelector from './index.vue'

export default function openProfileSkinSelectorModal () {
  modal.create(ProfileSkinSelector, true).app;
}
